import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowUp12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFolderArrowUp12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.023 3H2v1h3.634zM1 3v6.5A1.5 1.5 0 0 0 2.5 11h7A1.5 1.5 0 0 0 11 9.5v-4A1.5 1.5 0 0 0 9.5 4H6.806l-.93-1.521A1 1 0 0 0 5.022 2H2a1 1 0 0 0-1 1m5.245 2H9.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V5zm1.159 2.854a.5.5 0 0 1-.708 0L6.5 7.657V8.93a.5.5 0 0 1-1 0V7.636l-.218.218a.5.5 0 0 1-.707-.707l1.06-1.061.354-.354.354.354 1.06 1.06a.5.5 0 0 1 0 .708"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowUp12);
